import {configureStore as rtkConfigureStore} from '@reduxjs/toolkit'
import {promiseMiddleware} from './middleware';
import rootReducer from './reducers'
import {initialAppState} from './state/app.state';

function createAppStore(preloadedState) {
  return rtkConfigureStore({
    reducer: rootReducer,
    preloadedState,
    middleware: (getDefaultMiddleware) =>
      getDefaultMiddleware({serializableCheck: false, immutableCheck: false})
        .concat(promiseMiddleware),
  });
}

export const store = createAppStore(initialAppState);
